/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BaseMongoEntity } from './baseMongoEntity';
import { EntityStatus } from './entityStatus';
import { SubscriptionType } from './subscriptionType';
import { VasServiceTypeEnum } from './vasServiceTypeEnum';


export interface ServiceSubscriptionModel extends BaseMongoEntity { 
    referenceNumber?: string;
    serviceName?: string;
    serviceId?: string;
    serviceProviderName?: string;
    servicePlanName?: string;
    shortCode?: string;
    susbcriberPhoneNumber?: string;
    serviceExpiryDate: Date;
    status: number;
    creatorId?: string;
    subscriptionType: SubscriptionType;
    subscriptionContent?: string;
    hasNewMessage: boolean;
    subscriptionStatus: boolean;
    deliveryCount?: number;
    autoRenew: boolean;
    mnc?: string;
    mcc?: string;
    serviceCategory: VasServiceTypeEnum;
    serviceTypeName?: string;
}
